import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';

function ServiceShopSearch({ setModel, value, searchParam }) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const [search, setSearchBayi] = React.useState('');

    React.useEffect(() => {
        let active = true;
        if (search.length > 0 && open) {
            axios.get('/GetArtemisServiceShops/' + search.toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    if (active) {
                        if (res.data.length > 0) {
                            setOptions(res.data);
                        } else {
                            setOptions([]);
                        }
                    }
                }).catch(err => {
                    setOptions([]);
                });
        }
        return () => {
            active = false;
        };
    }, [search, open, loading]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchBayi(searchParam);
        }
    }, [searchParam]);

    const updateModel = model => {
        setModel(model);
        value.ACIKLAMA = model.BAYI_ACIKLAMA;
        value.KUL_BIRIM_KODU = model.KUL_BIRIM_KODU;
        value.BIRIM_KODU = model.BIRIM_KODU;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={open}
            value={value}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionLabel={(option) => { return option.KUL_BIRIM_KODU + ' - ' + option.ACIKLAMA }}
            options={options}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearchBayi(e.target.value) }}
                    variant="outlined"
                    label="Servis"
                    placeholder="Servis"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            filterOptions={(options, state) => options}
            loading={loading}
            onChange={(event, newValue) => {
                if (newValue && newValue.ACIKLAMA) {
                    updateModel(newValue);
                }
            }}
            
        />
    );
}

export default ServiceShopSearch;
